var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('placeholder-panel',[_c('h1',{staticClass:"display-3 text-center"},[_vm._v(" 👥"),_c('small',[_vm._v("?")])]),_c('h5',{staticClass:"text-center"},[_vm._v(" Select a "),_c('strong',[_vm._v("client")]),_vm._v(" for details ")])])}
var staticRenderFns = []

export { render, staticRenderFns }